/**
 * Texthjälpare för navbarens sökdialog, portade från sajtens
 * `app/utils/url.ts` (querify) och `app/utils/synonymify.ts` så att
 * understrykningen och synonymvisningen beter sig exakt som i ⌘K-modalen på
 * im.se.
 */

/** Sajtens normalisering av en fråga (NFC, gemener, utan skiljetecken). */
export function querify(str: string): string {
	return str
		.normalize('NFC')
		.toLowerCase()
		.trim()
		.replace(/\s{2,}/g, ' ')
		.replace(/[^\dA-Za-zŽžÀ-ÿ\s-]+/g, '') // behåll bindestreck för koder
		.replace(/--+/g, '-')
		.trim()
}

/**
 * Visar varför en träff kom upp när sökordet varken står i titeln eller
 * beskrivningen: första synonymen som innehåller ordet. Inte luddig - ett
 * felstavat ord ger ingen synonym - men räddar många fall (t.ex. koder).
 */
export function synonymify(
	synonyms: string | null,
	terms: string[],
	name: string,
	description: string,
): string {
	const nameAndDesc = `${name} ${description}`.toLowerCase()
	const syn = synonyms ?? ''
	let relevantSynonyms = ''
	for (const term of terms) {
		if (!term || nameAndDesc.includes(term)) continue
		// `querify` lämnar bara bokstäver, siffror, mellanslag och bindestreck,
		// men termen escapas ändå: den hamnar i en RegExp.
		const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
		const match = syn.match(new RegExp(`\\S*${escaped}\\S*`, 'i'))
		relevantSynonyms = match?.[0] ?? ''
	}
	return relevantSynonyms
}
